module.exports = __webpack_public_path__ + "static/sport/left-bg-m.18dbf20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/left-bg-m.png
// module id = YcOL
// module chunks = 0